import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { webUIBaseUrl, webUI } from "../endpoints";
// Define a service using a base URL and expected endpoints
export const favouritesService = createApi({
  reducerPath: "favouritesService",
  baseQuery: fetchBaseQuery({ baseUrl: webUIBaseUrl }),
  tagTypes: ["favourites"],
  endpoints: (builder) => ({
    getAllFavourites: builder.mutation({
      query(body) {
        return {
          url: `${webUI.favouriteController.getAllFavourite}?page=${body.page}&size=${body.size}&sort=${body.sort}`,
          method: "GET",
          // headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
    updateFavourite: builder.mutation({
      query(body) {
        return {
          url: `${webUI.favouriteController.updateFavourite}/${body.id}`,
          method: "PUT",
          // headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
    deleteFavouriteById: builder.mutation({
      query(body) {
        return {
          url: `${webUI.favouriteController.deleteFavouriteById}/${body.id}`,
          method: "DELETE",
        };
      },
    }),
    getFavouriteById: builder.mutation({
      query(body) {
        return {
          url: `${webUI.favouriteController.getFavouriteById}/${body.id}`,
          method: "GET",
          // headers: { Authorization: `Bearer ${body.token}`},
        };
      },
    }),
    saveFavourite: builder.mutation({
      query(body) {
        return {
          url: `${webUI.favouriteController.saveFavourite}`,
          method: "POST",
          // headers: { Authorization: `Bearer ${body.token}`},
          body: body.payload,
        };
      },
    }),
    getFavouriteByUserId: builder.mutation({
      query(body) {
        return {
          url: `${webUI.favouriteController.getFavouriteByUserId}/${body.userId}`,
          method: "GET",
          // headers: { Authorization: `Bearer ${body.token}`},
        };
      },
    }),
  }),
});
export const {
  useGetAllFavouritesMutation,
  useGetFavouriteByIdMutation,
  useDeleteFavouriteByIdMutation,
  useSaveFavouriteMutation,
  useUpdateFavouriteMutation,
  useGetFavouriteByUserIdMutation,
} = favouritesService;
